import { call, put, select, takeLatest } from 'redux-saga/effects'
import { createAction } from 'redux-starter-kit'
import { getDesmosConfig as getStaticDesmosConfig } from '@edulastic/common/src/utils/DesmosConfig'
import * as Sentry from '@sentry/browser'
import { notification } from '@edulastic/common'
import { createSelector } from 'reselect'
import appConfig from '../../../app-config'
import { getCurrentSchoolState } from '../../author/src/selectors/user'
import { getCurrentCalculatorTypeSelector } from '../../author/sharedDucks/testPlayer'

const FETCH_DESMOS_CONFIG = '[desmos calculator] fetch Desmos config'
const FETCH_DESMOS_CONFIG_SUCCESS =
  '[desmos calculator] fetch Desmos config - success'
const FETCH_DESMOS_CONFIG_FAILURE =
  '[desmos calculator] fetch Desmos config - failure'

// Actions
export const fetchDesmosConfigAction = createAction(FETCH_DESMOS_CONFIG)

const initialState = {
  config: null,
  error: null,
  loading: false,
}

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DESMOS_CONFIG:
      return { ...state, loading: true, error: null }
    case FETCH_DESMOS_CONFIG_SUCCESS:
      return { ...state, loading: false, error: null, config: action.payload }
    case FETCH_DESMOS_CONFIG_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

const addStandardConfigToStates = (cdnContent) => {
  Object.keys(cdnContent).forEach((calcType) => {
    const { standard: standardConfig, state: stateConfig } = cdnContent[
      calcType
    ]

    Object.keys(stateConfig).forEach((state) => {
      stateConfig[state] = { ...standardConfig, ...stateConfig[state] }
    })
  })
}

// Sagas
function* fetchDesmosConfigSaga() {
  try {
    const configInitialized = yield select((state) => state.desmos?.config)
    if (!configInitialized) {
      const config = yield call(() =>
        fetch(appConfig.desmosConfigPath, {
          cache: 'no-cache',
        }).then((response) => response.json())
      )
      addStandardConfigToStates(config)
      yield put({ type: FETCH_DESMOS_CONFIG_SUCCESS, payload: config })
    }
  } catch (error) {
    Sentry.captureException(error)
    notification({
      type: 'error',
      msg: 'Unable to load calculator. Please try again',
    })

    yield put({ type: FETCH_DESMOS_CONFIG_FAILURE, payload: error.message })
  }
}

export function* desmosSaga() {
  yield takeLatest(FETCH_DESMOS_CONFIG, fetchDesmosConfigSaga)
}

// Selectors
const stateSelector = (state) => state.desmos

export const getDesmosConfigSelector = createSelector(
  stateSelector,
  getCurrentSchoolState,
  getCurrentCalculatorTypeSelector,
  (state, stateName, calculateMode) => {
    return getStaticDesmosConfig(stateName, calculateMode, state.config)
  }
)
